import { useState, useEffect } from 'react';
import { axiosApi } from '../../api/setupApi';

const useCisNosoYears = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchYears = async () => {
      try {
        const { data } = await axiosApi.get('/cisNoso/years');
        setData(Array.isArray(data) ? data : []);
      } catch (err) {
        setError(err?.response?.data?.error || err?.message || 'Failed to fetch NOSO year data');
        setData([]);
      } finally {
        setLoading(false);
      }
    };

    fetchYears();
  }, []);

  return { data, loading, error };
};

export default useCisNosoYears;
